import { render, staticRenderFns } from "./Add-User.vue?vue&type=template&id=1b78e725"
import script from "./Add-User.vue?vue&type=script&lang=js"
export * from "./Add-User.vue?vue&type=script&lang=js"
import style0 from "./Add-User.vue?vue&type=style&index=0&id=1b78e725&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports